import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDataTable,{staticClass:"task--list",attrs:{"headers":_vm.headers,"items":_vm.milestones,"search":_vm.search,"sort-desc":[false, true],"multi-sort":""},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c(VBtn,{staticClass:"text-capitalize",attrs:{"color":"primary","link":""},on:{"click":function($event){return _vm.viewMilestone(item)}}},[_vm._v(" View "),_c(VIcon,{staticClass:"mx-2"},[_vm._v("visibility")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }